import { formatCountdown } from "@cede/utils";
import { useCountdown } from "@/hooks";

type RewardCountdownProps = {
  cooldownDate: Date;
};

export const RewardCountdown = ({ cooldownDate }: RewardCountdownProps) => {
  const countdown = useCountdown(cooldownDate);

  if (!countdown) return null;

  const isExpired = cooldownDate.getTime() <= Date.now();

  return (
    <p className="body2 text-right text-cede-primary">
      {isExpired ? "Ready to claim" : formatCountdown(countdown, "mini")}
    </p>
  );
};
